

module.exports = __webpack_require__.stylable.create(
    "Popover4225759737",
    {"classes":{"root":"Popover4225759737__root","arrow":"Popover602543466__arrow","withArrow":"Popover602543466__withArrow"},"vars":{},"stVars":{"contentArrowSize":"8px"},"keyframes":{}},
    "",
    2,
    "Popover4225759737",
    null
);
